<template>
  <div :class="classnames">
    <slot />
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'drawer-area'

  const modifiers = {
    isOpen: 'is-open'
  }

  export default {
    name: 'DrawerArea',
    components: {},
    mixins: [ bem ],
    props: {
      minHeight: {
        type: Number
      },
      contentHeight: {
        type: Number
      },
      isOpen: {
        type: Boolean
      }
    },
    data: function () {
      return {
        transition: ''
      }
    },
    watch: {
      'contentHeight': function () {
        this.animateHeight(this.contentHeight)
      },
      'isOpen': function () {
        this.handleStateIsOpen()
      }
    },
    created: function () {
      this.namespace = namespace
    },
    mounted: function () {
      this.handleStateIsOpen()
    },
    methods: {
      animateHeight: function (height) {
        this.disableTransition()

        const that = this

        requestAnimationFrame(function () {
          that.setHeight(height)
          that.enableTransition()
        })
      },
      classnameModifiers: function () {
        const isOpen = this.isOpen && modifiers.isOpen

        return [ isOpen ]
      },
      disableTransition: function () {
        this.transition = this.$el.style.transition
        this.$el.style.transition = ''
      },
      enableTransition: function () {
        this.$el.style.transition = this.transition
      },
      handleClose: function () {
        this.animateHeight(this.minHeight)
      },
      handleOpen: function () {
        this.animateHeight(this.contentHeight)
      },
      handleStateIsOpen: function () {
        const isOpen = this.isOpen

        if (isOpen) {
          this.handleOpen()
        } else {
          this.handleClose()
        }
      },
      setHeight: function (height) {
        const {
          $el
        } = this

        $el.style.height = this.isOpen ? `${height}px` : `0px`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Drawer/DrawerArea.vue